import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideModule } from 'ng-click-outside';
import { CurrentUserBoxModule } from '@app/theme/current-user-box/current-user-box.module';
import { ButtonModule } from '@app/theme/button/button.module';
import { RouterModule } from '@angular/router';
import { SideNavComponent } from './side-nav.component';

@NgModule({
  declarations: [SideNavComponent],
  imports: [
    RouterModule,
    CommonModule,
    ClickOutsideModule,
    CurrentUserBoxModule,
    ButtonModule,
  ],
  exports: [SideNavComponent],
})
export class SideNavModule {}
